import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/Icon';
import { Tag } from '~/components/Tag';

interface DropdownTagProps {
  children: ReactNode;
  disabled?: boolean;
  onRemove?: () => void;
}

export function DropdownTag({
  children,
  disabled = false,
  onRemove,
}: DropdownTagProps) {
  const { t } = useTranslation('components', { keyPrefix: 'dropdown' });
  // Prevents opening the dropdown when clicking on the tag
  const onClick = (e: React.MouseEvent) => {
    if (onRemove) {
      e.preventDefault();
      e.stopPropagation();
      onRemove();
    }
  };

  return (
    <Tag variant="secondary" className="min-w-0 break-all" disabled={disabled}>
      {children}
      {!disabled && onRemove ? (
        <button onClick={onClick} aria-label={t('removeOption')}>
          <Icon type="xmark" size="sm" aria-hidden />
        </button>
      ) : null}
    </Tag>
  );
}

DropdownTag.displayName = 'DropdownTag';
